<template>
  <div class="registration">
    <vue-title :title="$t('identityProvider:login:verifyOTPTitle')"></vue-title>
    <div v-if="model.showError">
      <h1 class="section-title">{{ $t('identityProvider:login:verifyOTPTitle') }}</h1>
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic">
        <i class="material-icons">warning</i>
        <span>{{ model.errorMessage }}</span>
      </div>
      <button type="button" v-on:click="loginCancel(logoutLink)" name="Action:RedirectToLogin" class="button" :disabled="disabled">{{ $t('shared:action:back') }}</button>
    </div>
    <div v-else>
      <form ref="form" action="authentication/submitverificationcode" @submit.prevent="validateBeforeSubmit">
        <h1 class="section-title">{{ $t('identityProvider:login:verifyOTPTitle') }}</h1>
        <fieldset>
          <div v-bind:class="alertContent" role="alert" v-show="!model.showError && model.errorMessage!=null" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic">
            <i class="material-icons" v-html="messageIcon"></i>
            <span class="pad-2">{{ model.errorMessage }}</span>
            <i class="material-icons ml-auto pointer" @click.prevent="closeBanner">close</i>
          </div>
          <div class="panel-message">
            {{ otpinstructionModel.instructions }}
          </div>
          <div class="form-group w-50">
            <label>
              <span class="item label">{{ $t('identityProvider:login:verifyOTPCodeHeader') }}</span>
            </label>
            <input type="text" id="txtverificationcode" :maxlength="complexityOtpModel.otpMaximumLength" v-model="model.verificationCode" name="verifyCode" class="w-100 mb-2 input-text control" v-validate="{ required: true, regex: complexityOtpModel.otpPattern, min: complexityOtpModel.otpMinimumLength, max: complexityOtpModel.otpMaximumLength }" autocomplete="off" v-bind:class="{ 'input-validation-error': hasErrorOn('verifyCode') }" />
            <span class="field-validation-error" v-show="hasErrorOn('verifyCode')">{{ errors.first('verifyCode') }}</span>
            <label  v-on:click.stop>
              <a @click.prevent="isLinkEnabled ? resendVerificationCode(resendLink) : 'return false;'" class="link">{{ $t('identityProvider:login:verifyOTPSendAnotherCode') }}</a><contextual-help-component :text="$t('identityProvider:login:tooltipSendAnotherCode')" data-test-element="sendanothercode-help" v-click-outside-tooltip="hideToolTip">{{ $t('identityProvider:login:tooltipSendAnotherCode') }}</contextual-help-component>
            </label>
          </div>
          <div class="form-actions mb-3">
            <button type="submit" class="button" :disabled="disabled">{{$t('shared:action:continue')}}</button>
            <a v-on:click="loginCancel(cancelLink)" class="button-secondary contextual-link" :data-test-element="'security-question-cancel'">{{ $t('shared:action:cancel') }}</a>
          </div>
          <div class="panel-message">
            <span>
              {{$t('identityProvider:login:verifyOTPNewPhoneNumber')}}
              <router-link :to="previousPageUrl">
                <span v-on:click="hideToolTip" class="link link-text-transform">{{$t('identityProvider:login:verifyOTPClickHere')}}</span>
              </router-link>
            </span>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import ContextualHelp from 'components/popper-help';
  import $ from 'jquery';
  import { deburr } from 'lodash';
  import redirect from '../../utils/redirect';

  Vue.component('contextual-help-component', ContextualHelp);

  Vue.directive("click-outside-tooltip", {
    bind(el, binding, vnode) {
      el.clickOutsideEvent = (event) => {
        if (!(el === event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    },
  });

  export default {
    mixins: [
      validation
    ],

    data: () => ({
      model: {
        verificationCode: null
      },
      challengeModel: {
        answer: null
      },
      messageIcon: null,
      alertContent: '',
      complexityOtpModel: {},
      otpinstructionModel: {},
      previousPageUrl: '',
      submitVerificationCodeModel: null,
      isLinkEnabled: true
    }),

    props: {
      submitVerificationCode: {
        type: Object,
        default: {
          action: "authentication/submitverificationcode",
          isOOBARegistration: true,
          challengeModel: null
        }
      },
      cancelLink: {
        default: "authentication/logincancel",
        type: String
      },
      resendLink: {
        default: "authentication/sendverificationcode",
        type: String
      },
      logoutLink: {
        default: "authentication/logincancel",
        type: String
      },
    },

    methods: {
      validateBeforeSubmit() {
        if (this.model != null) {
          this.model.errorMessage = null;
        }
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      },

      async post() {
        let form = this.$refs.form;
        try {
          let data = null;
          if (!this.submitVerificationCodeModel.isOOBARegistration) {
            this.challengeModel.answer = this.model.verificationCode;
            this.data = this.challengeModel;
          } else {
            this.data = this.model;
          }
          let response = await this.$http.post(this.submitVerificationCodeModel.action, this.data);
          redirectHandler.checkAndRedirect(response, this.$router);
          this.model = null;
          this.model = response.data;
          if (!this.model.success) {
            this.messageIcon = "warning";
            this.alertContent = "validation-summary-errors alert alert-danger fade show";
          }
        } catch (error) {
          if (this.validateResponse(form, error.response)) {
            return;
          }
          throw error;
        } finally {
        }
      },

      async loginCancel(path) {
        let response = await this.$http.post(path);
        redirectHandler.checkAndRedirect(response, this.$router);
      },

      async resendVerificationCode(path) {
        try {
          var resendLinkElement = event.target;
          this.$validator.reset();
          let response = await this.$http.post(path);
          redirectHandler.checkAndRedirect(response, this.$router);
          this.model = null;
          this.model = response.data;
          if (this.model.success) {            
            if (this.model.verificationCodeResentCount >= this.model.resendCodeLimit) {              
              resendLinkElement.className += ' disabled-link';
              this.isLinkEnabled = false;
            }
            this.messageIcon = "check_circle";
            this.alertContent = "validation-summary-valid alert alert-success fade show";
          }
        } catch (error) {
          let form = this.$refs.form;
          if (this.validateResponse(form, error.response)) {
            return;
          }
          throw error;
        }
      },

      closeBanner() {
        if (this.model != null) {
          this.model.errorMessage = null;
        }
      },

      hideToolTip() {
        var helpToolTip = document.getElementsByClassName('tooltip')[0];
        if (helpToolTip != undefined) {
          if (helpToolTip.classList.contains('show')) {
            var helpTrigger = document.getElementsByClassName('help-trigger')[0];
            helpTrigger.click();
          }
        }
      }
    },

    async created() {
      try {
        let response = null;
        if (this.submitVerificationCode.challengeModel != null) {
          response = this.submitVerificationCode.challengeModel;
        } else {
          response = await this.$http.get(this.submitVerificationCode.action);
        }
        this.complexityOtpModel = response.data.otpComplexity;
        this.otpinstructionModel = response.data;
        this.previousPageUrl = this.otpinstructionModel.previousPageUrl;
        this.submitVerificationCodeModel = this.submitVerificationCode;
      } catch (error) {
        let form = this.$refs.form;
        if (this.validateResponse(form, error.response)) {
          return;
        }
        throw error;
      }
    }
  };
</script>